//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React, { useEffect } from 'react'
import '@react/App.css'
import { BrowserRouter } from 'react-router-dom'
import { ErrorBoundary } from '@react/components/ErrorBoundary'

import LenderRouting from './LenderRouting'
import { useTheme } from '@mui/material'
import { LicenseInfo } from '@mui/x-license-pro'
import { SagaNavigationWrapper } from '@react/components/SagaNavigationWrapper'
import { useOtChainState, useOtDispatch } from '@react/redux/store'
import { fetchPoolAccountAccessPairs } from '@react/fetchers/PoolFetchers'
import { poolActions } from '@react/redux/poolSlice'
import { logOT } from '@shared/loggingShared'

LicenseInfo.setLicenseKey(
  '4aa820c74354bf0194df6f7dfa013a7fTz0xMTE4ODYsRT0xNzc3MDc1MTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
)

function LenderApp(): React.ReactElement {
  document.title = 'OpenTrade Lender'
  const theme = useTheme()
  const {
    stageConfiguration: { serverApiBaseUrl, restAPIKey },
    userConnection: { accountAddr },
  } = useOtChainState()
  const dispatch = useOtDispatch()
  useEffect(() => {
    if (accountAddr) {
      fetchPoolAccountAccessPairs(serverApiBaseUrl, restAPIKey, accountAddr).then((pairs) => {
        logOT.info('LenderApp pairs', pairs)
        dispatch(poolActions.addPoolAccountAccessPairs({ poolAccountAccessPairs: pairs }))
      })
    }
  }, [accountAddr, serverApiBaseUrl, restAPIKey])

  return (
    <div
      className="App"
      style={{ height: '100%', minHeight: '100vh', backgroundColor: theme.palette.background.canvas }}
    >
      <title>OpenTrade Lender </title>

      <BrowserRouter>
        <SagaNavigationWrapper>
          <ErrorBoundary>
            <LenderRouting />
          </ErrorBoundary>
        </SagaNavigationWrapper>
      </BrowserRouter>
    </div>
  )
}

export default LenderApp
